import { render } from "./AudiencesView.vue?vue&type=template&id=3d693816"
import script from "./AudiencesView.vue?vue&type=script&lang=js"
export * from "./AudiencesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__